type createMapParams = {
  map?: google.maps.Map;
  element?: HTMLElement | null;
  mapOptions: google.maps.MapOptions;
  setMap: (e: google.maps.Map) => void;
};

export function createMap({
  element,
  setMap,
  map,
  mapOptions,
}: createMapParams) {
  if (element && !map)
    setMap(new window.google.maps.Map(element, { ...mapOptions }));
}
